import { render, staticRenderFns } from "./StudentDemeanor.vue?vue&type=template&id=f8d45c1a&scoped=true&"
import script from "./StudentDemeanor.vue?vue&type=script&lang=js&"
export * from "./StudentDemeanor.vue?vue&type=script&lang=js&"
import style0 from "./StudentDemeanor.vue?vue&type=style&index=0&id=f8d45c1a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d45c1a",
  null
  
)

export default component.exports